import { Market, Supplier } from '../types';

// A missing supplier is treated as non-Polymarket so Sweeps updates are never dropped.
export const isSupplierForProduct = (supplier: Supplier | undefined, isPredictions: boolean) =>
    isPredictions ? supplier === 'POLYMARKET' : supplier !== 'POLYMARKET';

export const filterMarketsForProduct = (markets: Market[], isPredictions: boolean) =>
    markets.filter(market => isSupplierForProduct(market.supplier, isPredictions));
